import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import Image from 'next/image'
import { FC } from 'react'

import { useQRCode } from './hooks/useQRCode'

type Props = {
  invoiceId?: string
  qrContent?: string
}

const QrCodeForm: FC<Props> = ({ invoiceId, qrContent }) => {
  const qrCode = useQRCode({ invoiceId, qrContent })

  return (
    <div className="mt-32 flex flex-col gap-16 sm:mt-20">
      <div className="flex gap-x-8">
        <ExclamationCircleIcon className="h-24 w-24 flex-shrink-0 text-grey-60" />
        <p className="text-20 xs:text-16">
          Откройте приложение банка и наведите камеру на QR-код. Счёт
          сформируется автоматически
        </p>
      </div>
      <div className="flex gap-x-8">
        <ExclamationCircleIcon className="h-24 w-24 flex-shrink-0 text-grey-60" />
        <p className="text-20 xs:text-16">
          При оплате по QR-коду вы можете оплатить только полную сумму
          выставленного счёта
        </p>
      </div>
      <div className="flex justify-center p-24">
        {qrCode && (
          <Image width={320} height={320} src={qrCode} alt="qr_code" />
        )}
      </div>
    </div>
  )
}

export default QrCodeForm
